import { Language } from '@yleisradio/areena-types';
import { getTranslation } from '../localizations/translations';
import { cloudinaryHostname } from '../environment';

const accessibilityStatementQrFi = `https://${cloudinaryHostname}/image/upload/v1749644854/areena/accessibility_statement_fi_pnkv8x.png`;
const accessibilityStatementQrSv = `https://${cloudinaryHostname}/image/upload/v1749644854/areena/accessibility_statement_sv_rcs61k.png`;

/*
 * Content needs to be valid XHTML because of HBBTV-support, verify any changes with this setup!
 */
export function generateAccessibilityStatementHtml(
  language: Language,
  title: string
): string {
  return `
    <h1>${title}</h1>
    <div class="logo-with-text">
      <img src="${
        language === 'sv'
          ? accessibilityStatementQrSv
          : accessibilityStatementQrFi
      }" />
        <div class="logo-text">
          <p>${getTranslation('viewSettings_accessibilityInfoText', language)}</p>
        </div>
    </div>
  `;
}
